<script>
import Page from '../../components/page.vue'
import Tabs from '../../components/tabs.vue'
import TabPane from '../../components/tab-pane.vue'
import Tree from '../../components/tree.vue'
import { getCourseDetail } from '../../api/portal'
import { courseDefaultCover } from '../../config/values'
export default {
  components: {
    Page,
    Tabs,
    TabPane,
    Tree
  },
  data: function () {
    return {
      detail: {},
      activeName: 'chapters',
      defaultCover: courseDefaultCover,
      loaded: false
    }
  },
  async mounted () {
    await this.fetch()
  },
  methods: {
    async fetch () {
      this.loaded = false
      const { data } = await getCourseDetail(this.$route.params.id)
      this.detail = data.body
      this.loaded = true
    }
  }
}
</script>

<template>
  <Page title="课程详情">
    <template v-if="loaded">
      <img :src="detail.logo || defaultCover" :alt="detail.title" :class="$style.cover" />
      <div :class="$style.section">
        <div :class="$style.title">
          <div :class="$style.name">{{detail.title}}</div>
          <div :class="$style.people">{{detail.learnNum}}人参与</div>
        </div>
        <div :class="$style.tags" v-if="detail.courseTagList && courseTagList.length > 0">
          <div v-for="(item, index) in detail.courseTagList" :key="index">{{item.tagname}}</div>
        </div>
        <div :class="$style.meta">
          <div v-if="detail.opencourseschool">
            <span>开课院校</span>
            <span>{{detail.opencourseschool}}</span>
          </div>
          <div v-if="detail.recommendstudytime !== null && detail.recommendstudytime !== undefined">
            <span>建议学习时长</span>
            <span>{{detail.recommendstudytime}}课时</span>
          </div>
          <div v-if="detail.subjectClassify">
            <span>学科分类</span>
            <span>{{detail.subjectClassify}}</span>
          </div>
          <div v-if="detail.types">
            <span>课程分类</span>
            <span>{{detail.types}}</span>
          </div>
          <div v-if="detail.teachingLevel">
            <span>课程层次</span>
            <span>{{detail.teachingLevel}}</span>
          </div>
          <div v-if="detail.honor">
            <span>荣誉属性</span>
            <span>{{detail.honor}}</span>
          </div>
        </div>
      </div>
      <div :class="$style.section" v-if="detail.courseTeachers && detail.courseTeachers.length">
        <div :class="$style.teamLabel">课程团队</div>
        <ul
          :class="$style.team"
          :style="detail.courseTeachers.length === 1  ? 'justify-content: center' : ''"
        >
          <li v-for="(item) in detail.courseTeachers" :key="item.id">
            <img :src="item.headimage" />
            <div :class="$style.leader">{{item.name}}</div>
            <div :class="$style.orgname">{{item.orgname}}</div>
          </li>
        </ul>
      </div>
      <div :class="$style.section">
        <Tabs v-model="activeName" gutter="16px">
          <TabPane name="chapters" label="章节目录">
            <div :class="$style.outline" v-html="detail.teachingoutline"></div>
          </TabPane>
          <TabPane name="desc" label="课程介绍">
            <div :class="$style.intro" v-html="detail.description"></div>
          </TabPane>
          <TabPane name="outline" label="课程资源">
            <Tree :data="detail.outlineList"></Tree>
          </TabPane>
        </Tabs>
      </div>
    </template>
  </Page>
</template>

<style lang="stylus" module>
.cover
  display block
  width 100%
  max-height 220px
  object-fit cover

.section
  padding 12px
  margin-bottom 8px
  background-color #fff

.title
  display flex
  justify-content space-between
  align-items flex-start
  margin-bottom 16px

  /.name
    flex 1
    font-size 18px
    line-height 26px
    max-width 75%

  /.people
    flex 0 0 auto
    color $gray-400
    small-font()

.tags
  margin-bottom 8px
  font-size 0
  color $primary-color

  > div
    display inline-block
    font-size 12px
    line-height 22px
    height 22px
    padding 0 4px
    border 1px solid $primary-color
    margin-right 12px
    max-width 100%
    ellipsis()

.meta
  font-size 12px
  line-height 20px
  color $gray-400

  > div
    display flex

  span
    flex 1

.teamLabel
  middle-font()
  padding-left 8px
  border-left 4px solid $primary-color
  margin-bottom 12px

.team
  display flex
  text-align center
  overflow-x auto

  > li
    width 50%
    flex 0 0 auto

  img
    width 80px
    height 80px
    object-fit cover
    display block
    margin 0 auto 11px
    border-radius 50%

.leader
  middle-font()
  margin-bottom 6px

.orgname
  color $gray-400
  small-font()
  margin-bottom 18px
  ellipsis()

.intor, .outline
  font-size 14px
  line-height 22px
</style>
